var Avatar = /** @class */ (function () {
    function Avatar(UsersDetails) {
        this.getFullName = UsersDetails.getFullName;
        this.isActive = UsersDetails.isActive;
    }
    Avatar.$inject = ['UsersDetails'];
    return Avatar;
}());
export default {
    controller: Avatar,
    template: require('./users.details.avatar.html'),
    bindings: { user: '<' }
};
//# sourceMappingURL=users.details.avatar.js.map